import React from "react";
// import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import DashNav from "../../../Components/DashNav/DashNav";
import "./Employees.css";
// import { getAllCustomers } from "../../../api";
import Gbtn from "../../../Components/buttons/Gbtn";
import { FiEdit } from "react-icons/fi";
import { RiSignalWifiErrorLine, RiDeleteBin6Line } from "react-icons/ri";
import EmployeeSVG from "../../../Components/SVGS/EmployeeSVG";
import LoadingSpinner from "../../../Components/LoadingSpinner/LoadingSpinner";

function Employees() {
  const icon = () => {
    return <EmployeeSVG size="22" fill="black" />;
  };

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [role_id, setRole_id] = useState(4);
  const [totalRecords, setTotalRecords] = useState(10);
  const [employeesData, setEmployeesData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [paginationDisplay, setPaginationDisplay] = useState("block");
  const [err, setErr] = useState(false);
  const [searchString, setSearchString] = useState("");

  useEffect(() => {
    fetchAllData(page);
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchString.trim() !== "") {
        fetchAllData(page, searchString);
      }
    }, 1500);
    return () => {
      clearTimeout(delay);
    };
  }, [searchString]);

  const fetchAllData = (pageNumber, searchTxt) => {
    setisLoading(true);
    // getAllCustomers(limit, pageNumber, searchTxt, role_id)
    //   .then(({ data }) => {
    //     setEmployeesData(data.result);
    //     setTotalRecords(data.total_records);
    //     setErr(false);
    //     setisLoading(false);
    //     setPaginationDisplay("block");
    //     setPage(pageNumber);
    //   })
    //   .catch((ERR) => {
    //     console.log("ERR", ERR);
    //     setErr(true);
    //     setPaginationDisplay("none");
    //     setErrorMsg("Network Error! Check your Network connection");
    //     setisLoading(false);
    //   });
  };

  //   const Options = [
  //     { value: "dept1", label: "dept1" },
  //     { value: "dept1", label: "dept4" },
  //     { value: "dept1", label: "dept3" },
  //     { value: "dept1", label: "dept2" },
  //   ];

  const handlePageChange = (pageNumber) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (pageNumber >= 1) {
      fetchAllData(pageNumber, searchString);
    }
  };

  const handleSearch = (e) => {
    setSearchString(e.target.value);
    if (e.target.value === "") {
      fetchAllData(page);
    }
  };

  const navigate = useNavigate("");
  const addOnclick = () => {
    navigate("/dashboard/employees/empAdd");
  };

  return (
    <>
      <div className="mainDashView">
        <div>
          <DashNav svg={icon} DashboardNavText="Employees" />
        </div>

        <div className="dashPanel">
          <div className="eViewBar">
            <div className="eViewBar2">
              <div>
                <input
                  type="search"
                  value={searchString}
                  onChange={handleSearch}
                  placeholder="Search by name/email"
                  className="employeeSearch"
                />
              </div>
            </div>
            <div className="eView-btn">
              <Gbtn text="Add" color="#4ab493" func={addOnclick} />
            </div>
          </div>
          {isLoading ? (
            <LoadingSpinner />
          ) : err ? (
            <div className="network-err-msg">
              <RiSignalWifiErrorLine /> {errorMsg}
            </div>
          ) : employeesData ? (
            <table className="employeViewTable">
              <thead>
                <tr>
                  <th
                    style={{
                      borderTopLeftRadius: "16px",
                      borderBottomLeftRadius: "16px",
                    }}
                  >
                    First Name
                  </th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Gender</th>
                  <th>Role</th>
                  <th>Salary</th>
                  <th>Age</th>
                  <th>Status</th>
                  <th
                    style={{
                      borderStartEndRadius: "16px",
                      borderEndEndRadius: "16px",
                    }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {employeesData
                  .filter((user) => user.employee != null)
                  .map((data) => (
                    <Rows data={data} />
                  ))}
              </tbody>
            </table>
          ) : (
            <div className="network-err-msg">NO Data Exist!</div>
          )}
          <div className="paginationDiv" style={{ display: paginationDisplay }}>
            <Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalRecords}
              pageRangeDisplayed={3}
              onChange={(pageNumber) => {
                handlePageChange(pageNumber);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

const Rows = ({ data }) => {
  const navigate = useNavigate("");
  const editEmp = () => {
    navigate("/dashboard/employees/empDetails", {
      state: { empDetails: data },
    });
  };
  const employee = data.employee;
  const age = (dob) => {
    let today = new Date();
    let birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    return age;
  };
  return (
    <>
      {data && data ? (
        <tr>
          <td>
            {employee.first_name.length > 16
              ? employee.first_name.substring(0, 15) + " . . ."
              : employee.first_name}
          </td>
          <td>
            {employee.last_name.length > 16
              ? employee.last_name.substring(0, 15) + " . . ."
              : employee.last_name}
          </td>
          <td>
            {data.email.length > 30
              ? data.email.substring(0, 28) + " . . ."
              : data.email}
          </td>
          <td>{employee.gender === 1 ? "Male" : "Female"}</td>
          <td>{"Employee"}</td>
          <td>{employee.salary}</td>
          <td>{age(employee.dob)}</td>
          <td>{employee.status === 1 ? "Active" : "Disable"}</td>
          <td
            style={{
              display: "flex",
              justifyContent: "center",
              minWidth: "60px",
            }}
          >
            <button onClick={editEmp} className="Actionbtn editBtn">
              <FiEdit />
            </button>
            <button onClick={editEmp} className="Actionbtn delBtn">
              <RiDeleteBin6Line />
            </button>
          </td>
        </tr>
      ) : null}
    </>
  );
};
// const Stat = (props)=>{
//     const styl = {
//         padding: "6px 6px", border: "lightgray", backgroundColor:"whitesmoke",
//         borderRadius: "5px", color:"gray",
//     }
//     return(
//         <>
//             <div>
//                 <select name="" style={styl}>
//                     <option value="" selected="selected">{props.val}</option>
//                     <option value="">{props.val === "active" ? "Disable": "Acvtive"}</option>
//                 </select>
//             </div>
//         </>
//     )
// }

export default Employees;
